import axios from 'axios'
import {Message} from 'element-ui'
import router from '../router/index'

axios.defaults.timeout = 60000
// axios.defaults.baseURL = 'http://42.51.181.42:16666/api'
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
axios.defaults.baseURL = 'http://42.51.181.51:9999/api'

axios.defaults.withCredentials = true

axios.interceptors.request.use(
    request => {
        if (localStorage.getItem('jwt')) {
            request.headers.authorization = 'Bearer ' + localStorage.getItem('jwt')
        }
        return request
    },
    err => Promise.reject(err)
)

axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        console.log('出错了：',error.response)
        if (error.response.status) {
            if (error.response.status == 401) {
                if (error.response.data.code == "token_not_valid") {
                    Message.error('登录过期，请重新登陆')
                    router.push({path: '/login'})
                } else if (error.response.statusText == "Unauthorized") {
                    Message.error('密码错误')                    
                }
            } else if (error.response.status == 400) {
                Message.error(error.response.data[0])
            } else if (error.response.status == 404) {
                Message.error('没有数据')
            } else {
                Message.error(error.response.data)
            }
        }
    }
)
export default axios
